/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type DmvsGadDocsCloseInterruptPartialUpdateRequest = {} | null | undefined;
export type DmvsGadDocsCloseInterruptPartialUpdateResponse = any;

export type DmvsGadDocsCloseInterruptPartialUpdateQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this doc.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * PATCH /dmx-server/dmvs_gad_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_close_interrupt_partial_update
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsCloseInterruptPartialUpdateOperation = ({
  id,
  ...rest
}: DmvsGadDocsCloseInterruptPartialUpdateQuery) =>
  ({
    method: 'PATCH',
    path: `/dmx-server/dmvs_gad_docs/${id}/close_interrupt/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'PATCH';
    path: string & { _templateUrl: '/dmx-server/dmvs_gad_docs/{id}/close_interrupt/' };
  };

/**
 * PATCH /dmx-server/dmvs_gad_docs/{id}/close_interrupt/
 *
 * ```yaml
 * operationId: dmvs_gad_docs_close_interrupt_partial_update
 * tags:
 *   - dmvs_gad_docs
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '200':
 *     description: No response body
 * ```
 */
export const dmvsGadDocsCloseInterruptPartialUpdate = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: DmvsGadDocsCloseInterruptPartialUpdateQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = dmvsGadDocsCloseInterruptPartialUpdateOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'PATCH',
    request,
    onUploadProgress,
    cancelToken,
  );
};
